import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class RelatedArticles extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        const swiper = new Swiper(this.querySelector('.related-article-js'), {
            // Optional parameters
            freeMode: true,
            modules: [Navigation],
            centerInsufficientSlides: true,
            loop: false,
            navigation: {
                nextEl: '.button-next',
                prevEl: '.button-prev',
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
                1110: {
                    slidesPerView: 4,
                    spaceBetween: 32,
                },
            },
        })
    }
}

customElements.define('related-articles', RelatedArticles)
